import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const PermissionsNeeded = ({ height = '150', width = '150', ...props }: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 213 158" fill="none" {...props}>
    <path
      d="M204.915 97.3237C204.914 82.8189 201.666 68.4983 195.41 55.4118C189.154 42.3253 180.049 30.8048 168.762 21.695C157.475 12.5851 144.292 6.11689 130.18 2.76451C116.068 -0.587861 101.384 -0.739374 87.2061 2.32108C73.0278 5.38154 59.7142 11.5764 48.2415 20.4514C36.7688 29.3264 27.4277 40.6565 20.9033 53.6111C14.3789 66.5657 10.8364 80.8163 10.5358 95.318C10.2351 109.82 13.1838 124.205 19.1657 137.419H196.264C201.978 124.825 204.927 111.153 204.915 97.3237V97.3237Z"
      fill="#F5F4F4"
    />
    <path d="M11.73 137.418H201.27" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M0.794922 137.418H6.86992"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M206.13 137.418H212.205"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M167.08 160.262C167.08 162.692 140.35 164.879 107.132 164.879C73.9137 164.879 47.208 162.813 47.208 160.262C47.208 157.71 73.938 155.645 107.132 155.645C140.326 155.645 167.08 157.832 167.08 160.262Z"
      fill="#F5F4F4"
    />
    <path
      d="M173.228 154.111C173.231 154.516 173.154 154.916 173.002 155.291C172.849 155.665 172.624 156.005 172.34 156.292C172.055 156.579 171.716 156.807 171.343 156.962C170.97 157.118 170.57 157.198 170.166 157.198H92.0414C91.2229 157.198 90.438 156.872 89.8592 156.294C89.2805 155.715 88.9553 154.93 88.9553 154.111V46.5354C88.9553 45.7169 89.2805 44.9319 89.8592 44.3532C90.438 43.7744 91.2229 43.4493 92.0414 43.4493H156.582C156.988 43.4467 157.391 43.5248 157.766 43.6792C158.141 43.8335 158.482 44.061 158.769 44.3484L172.329 57.9078C172.616 58.1945 172.843 58.5355 172.998 58.911C173.152 59.2864 173.23 59.6888 173.228 60.0948V154.111Z"
      fill="white"
    />
    <path
      d="M173.228 154.111C173.231 154.516 173.154 154.916 173.002 155.291C172.849 155.665 172.624 156.005 172.34 156.292C172.055 156.579 171.716 156.807 171.343 156.962C170.97 157.118 170.57 157.198 170.166 157.198H92.0414C91.2229 157.198 90.438 156.872 89.8592 156.294C89.2805 155.715 88.9553 154.93 88.9553 154.111V46.5354C88.9553 45.7169 89.2805 44.9319 89.8592 44.3532C90.438 43.7744 91.2229 43.4493 92.0414 43.4493H156.582C156.988 43.4467 157.391 43.5248 157.766 43.6792C158.141 43.8335 158.483 44.061 158.769 44.3484L172.329 57.9078C172.616 58.1945 172.843 58.5355 172.998 58.911C173.152 59.2864 173.23 59.6888 173.228 60.0948V154.111Z"
      stroke="#6A266D"
      strokeLinejoin="round"
    />
    <path
      d="M108.954 80.3359H156.582"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M113.28 71.1289H133.716"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M108.954 89.5703H156.582"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M108.954 98.7812H156.582"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M157.87 56.038C157.87 56.405 157.943 56.7684 158.083 57.1074C158.224 57.4464 158.429 57.7545 158.689 58.014C158.948 58.2735 159.256 58.4793 159.595 58.6198C159.934 58.7602 160.298 58.8325 160.665 58.8325H172.815C172.674 58.4885 172.467 58.175 172.207 57.9091L158.769 44.3497C158.502 44.1037 158.199 43.899 157.87 43.7422V56.038Z"
      fill="#B56DC6"
      stroke="#6A266D"
      strokeLinejoin="round"
    />
    <path
      d="M44.6321 126.457H120.472C123.05 126.457 125.523 127.481 127.345 129.304C129.168 131.127 130.192 133.599 130.192 136.177V145.533C130.192 146.177 129.936 146.795 129.481 147.251C129.025 147.707 128.407 147.963 127.762 147.963H37.3421C36.6976 147.963 36.0796 147.707 35.6238 147.251C35.1681 146.795 34.9121 146.177 34.9121 145.533V136.177C34.9121 133.599 35.9362 131.127 37.759 129.304C39.5819 127.481 42.0542 126.457 44.6321 126.457Z"
      fill="white"
    />
    <path
      d="M44.6321 126.457H120.472C123.05 126.457 125.523 127.481 127.345 129.304C129.168 131.127 130.192 133.599 130.192 136.177V145.533C130.192 146.177 129.936 146.795 129.481 147.251C129.025 147.707 128.407 147.963 127.762 147.963H37.3421C36.6976 147.963 36.0796 147.707 35.6238 147.251C35.1681 146.795 34.9121 146.177 34.9121 145.533V136.177C34.9121 133.599 35.9362 131.127 37.759 129.304C39.5819 127.481 42.0542 126.457 44.6321 126.457Z"
      stroke="#6A266D"
      strokeLinejoin="round"
    />
    <path
      d="M96.9501 86.4856H68.1546C67.4827 86.4751 66.8174 86.3519 66.1863 86.1211C67.6929 89.2558 71.7996 100.191 71.7996 126.459H93.3051C93.3051 100.191 97.4118 89.2558 98.9184 86.1211C98.2873 86.3519 97.622 86.4751 96.9501 86.4856Z"
      stroke="#6A266D"
      strokeLinejoin="round"
    />
    <path
      d="M123.145 155.399C122.965 155.959 122.611 156.447 122.135 156.792C121.658 157.137 121.085 157.322 120.497 157.319H44.6078C44.0197 157.322 43.446 157.137 42.9698 156.792C42.4936 156.447 42.1396 155.959 41.9591 155.399L39.5291 148.109H125.6L123.145 155.399Z"
      fill="#B56DC6"
      stroke="#6A266D"
      strokeLinejoin="round"
    />
    <path d="M71.6052 117.227H93.4995" stroke="#6A266D" strokeLinejoin="round" />
    <path
      d="M96.9501 86.4856H68.1546C67.4827 86.4751 66.8174 86.3519 66.1863 86.1211C67.6929 89.2558 71.7996 100.191 71.7996 126.459H93.3051C93.3051 100.191 97.4118 89.2558 98.9184 86.1211C98.2873 86.3519 97.622 86.4751 96.9501 86.4856Z"
      fill="white"
    />
    <path
      d="M96.9501 86.4856H68.1546C67.4827 86.4751 66.8174 86.3519 66.1863 86.1211C67.6929 89.2558 71.7996 100.191 71.7996 126.459H93.3051C93.3051 100.191 97.4118 89.2558 98.9184 86.1211C98.2873 86.3519 97.622 86.4751 96.9501 86.4856Z"
      stroke="#6A266D"
      strokeLinejoin="round"
    />
    <path
      d="M97.6792 61.8945H67.4257C64.7416 61.8945 62.5657 64.0704 62.5657 66.7545V81.6261C62.5657 84.3102 64.7416 86.4861 67.4257 86.4861H97.6792C100.363 86.4861 102.539 84.3102 102.539 81.6261V66.7545C102.539 64.0704 100.363 61.8945 97.6792 61.8945Z"
      fill="white"
    />
    <path
      d="M97.6792 61.8945H67.4257C64.7416 61.8945 62.5657 64.0704 62.5657 66.7545V81.6261C62.5657 84.3102 64.7416 86.4861 67.4257 86.4861H97.6792C100.363 86.4861 102.539 84.3102 102.539 81.6261V66.7545C102.539 64.0704 100.363 61.8945 97.6792 61.8945Z"
      stroke="#6A266D"
      strokeLinejoin="round"
    />
    <path
      d="M150.563 122.367V129.24"
      stroke="#2489A9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M150.434 144.901C158.93 144.901 165.816 138.014 165.816 129.519C165.816 121.023 158.93 114.137 150.434 114.137C141.939 114.137 135.052 121.023 135.052 129.519C135.052 138.014 141.939 144.901 150.434 144.901Z"
      fill="#E6FBFF"
      stroke="#2489A9"
      strokeMiterlimit="10"
    />
    <path
      d="M150.563 122.367V129.24"
      stroke="#2489A9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M151.062 135.952C150.914 135.853 150.74 135.801 150.563 135.801C150.324 135.801 150.096 135.895 149.927 136.064C149.759 136.233 149.664 136.461 149.664 136.699C149.664 136.877 149.717 137.051 149.816 137.199C149.914 137.347 150.055 137.462 150.219 137.53C150.383 137.598 150.564 137.616 150.738 137.581C150.912 137.546 151.073 137.461 151.198 137.335C151.324 137.209 151.409 137.049 151.444 136.875C151.479 136.7 151.461 136.52 151.393 136.356C151.325 136.191 151.21 136.051 151.062 135.952ZM149.564 135.205C149.86 135.008 150.207 134.902 150.563 134.902C151.039 134.902 151.496 135.092 151.833 135.429C152.171 135.766 152.36 136.223 152.36 136.699C152.36 137.055 152.254 137.402 152.057 137.698C151.86 137.993 151.579 138.224 151.25 138.36C150.922 138.496 150.561 138.531 150.212 138.462C149.864 138.393 149.543 138.222 149.292 137.97C149.041 137.719 148.869 137.399 148.8 137.05C148.731 136.701 148.766 136.34 148.902 136.012C149.038 135.683 149.269 135.403 149.564 135.205Z"
      fill="#2489A9"
      stroke="#2489A9"
    />
  </SvgIcon>
);
